import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import Header from "../core/common/header/header";
import Sidebar from "../core/common/sidebar/sidebar";
import SidebarTwo from "../core/common/sidebar-two/sidebarTwo";
import Sidebarthree from "../core/common/sidebarthree/sidebarthree";
import ThemeSettings from "../core/common/theme-settings";

const Feature = () => {
  const locations = useLocation();
  const path = locations.pathname;

  const themeSettings = useSelector((state: any) => state.theme.themeSettings);
  const { miniSidebar, mobileSidebar, expandMenu } = useSelector(
    (state: any) => state.sidebarSlice
  );

  const dataLayout = themeSettings["data-layout"];
  const dataWidth = themeSettings["data-width"];
  const dataSize = themeSettings["data-size"];
  const dir = themeSettings["dir"];

  // Handle RTL mode on body tag
  useEffect(() => {
    if (dir === "rtl") {
      document.body.classList.add("layout-mode-rtl");
    } else {
      document.body.classList.remove("layout-mode-rtl");
    }
    
    return () => {
      document.body.classList.remove("layout-mode-rtl");
    };
  }, [dir]);

  return (
    <>
      <div
        className={`
        ${
          miniSidebar || dataLayout === "mini" || dataSize === "compact"
            ? "mini-sidebar"
            : ""
        }
        ${
          (expandMenu && miniSidebar) || (expandMenu && dataLayout === "mini")
            ? "expand-menu"
            : ""
        }
        ${mobileSidebar ? "menu-opened slide-nav" : ""}
        ${dataWidth === "box" ? "layout-box-mode mini-sidebar" : ""}
      `}
      >
        <>
          {/* <Preloader /> */}
          <div className="main-wrapper">
            <Header />
            {path.startsWith("/super-admin") ? (
              <SidebarTwo />
            ) : [
                "/customer/customer-dashboard",
                "/customer/customer-quotations",
                "/customer/customer-invoices",
                "/customer/customer-recurring-invoices",
                "/customer/customer-transactions",
                "/customer/customer-payment-summary",
                "/customer/customer-invoice-report",
                "/customer/customer-account-settings",
                "/customer/customer-security-settings",
                "/customer/customer-plans-settings",
                "/customer/customer-notification-settings",
              ].some((p) => path.startsWith(p)) ? (
              <Sidebarthree />
            ) : (
              <Sidebar />
            )}
            <Outlet />
            <ThemeSettings />
          </div>
        </>
        {/* <Loader/> */}

        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
